import { TFunction } from 'i18next';
import { ReturnFrequency } from 'store/api/enums';

const RETURN_FREQUENCY_KEYS = [
  'WEEKLY',
  'FORNIGHTLY',
  'MONTHLY',
  'TWO_MONTHS',
  'FOUR_MONTHS',
  'SIX_MONTHS',
  'QUARTERLY',
  'YEARLY',
  'BI_YEARLY',
] as const;

type ReturnFrequencyKey = (typeof RETURN_FREQUENCY_KEYS)[number];

const isReturnFrequencyKey = (value: string): value is ReturnFrequencyKey =>
  (RETURN_FREQUENCY_KEYS as readonly string[]).includes(value);

/** Localized label for a ReturnFrequency enum key (e.g. QUARTERLY → "Quarterly" / "Τριμηνιαία"). */
export const getReturnFrequencyLabel = (
  frequencyKey: string | undefined | null,
  t: TFunction
): string => {
  if (!frequencyKey) return '';

  if (isReturnFrequencyKey(frequencyKey)) {
    return t(`common.return-frequency.${frequencyKey}`, {
      defaultValue: ReturnFrequency[frequencyKey],
    });
  }

  // Already a display value (e.g. "Quarterly") — map back via enum values when possible.
  const enumKey = (
    Object.keys(ReturnFrequency) as Array<keyof typeof ReturnFrequency>
  ).find((key) => ReturnFrequency[key] === frequencyKey);

  if (enumKey && isReturnFrequencyKey(enumKey)) {
    return t(`common.return-frequency.${enumKey}`, {
      defaultValue: frequencyKey,
    });
  }

  return frequencyKey;
};
